// extracted by mini-css-extract-plugin
export default {"FormInput":"input_FormInput__m2TLh","invalid":"input_invalid__90J32"};